<template>
  <div>
    <div class="center_wrap">
      <div class="wrap_l">
        <!-- 委托信息模块start -->
        <div class="Item_list">
          <div class="weituo">
            <img src="../../assets/weituo.png" alt="" />
            <p class="tittype">{{$t('i18n_Order_info')}}</p>
          </div>
          <el-form label-position="right" label-width="106px" size="small" :rules="entrustInfoRules" ref="entrustForm" :model="entrustInfo">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_contact_person')">
                  <el-input
                    disabled
                    v-model="Authorization.customerContact"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('i18n_contact_number')">
                  <el-input
                    disabled
                    v-model="Authorization.customerTel"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_entrusting_company')">
                  <el-input disabled v-model="Authorization.namec"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="height: 51px">
                <el-form-item :label="$t('i18n_pay_party')" prop="payType">
                  <el-radio-group
                    v-model="entrustInfo.payType"
                    style="width: 100%"
                  >
                    <el-radio label="PP">{{$t('i18n_domestic_payment')}}</el-radio>
                    <el-radio label="CC">{{$t('i18n_foreign_payment')}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_estimated_receiving_time')" prop="inWarehouseTime">
                  <el-date-picker
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :placeholder="addPls('i18n_warehouse_received_time', 'select')"
                    v-model="entrustInfo.inWarehouseTime"
                    style="width: 100%"
                    :picker-options="pickerSetTime"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="height: 51px">
                <el-form-item :label="$t('i18n_clearance_metods')" prop="customsClearanceType">
                  <!-- <el-select
                    placeholder="请选择"
                    v-model="entrustInfo.customsClearanceType"
                    style="width: 100%"
                  >
                    <el-option label="自清" value="Z"></el-option>
                    <el-option label="亦邦双清" value="S"></el-option>
                  </el-select> -->
                  <el-radio-group
                    v-model="entrustInfo.customsClearanceType"
                    style="width: 100%"
                  >
                    <el-radio label="Z">{{$t('i18n_self_clearing')}}</el-radio>
                    <el-radio label="S">{{$t('i18n_Cititran_incharges_of_double_clearing')}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_logistics_services')">
                  <el-input
                    disabled
                    v-model="productName"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <!-- 委托信息模块end -->
        <!-- 地址信息模块start -->
        <div class="Item_list">
          <addressInfo
            :sendFeeForAir="sendFeeForAir"
            :getGoodsDTO="getGoodsDTO"
            :recGoodsDTO="recGoodsDTO"
            :delGoodsDTO="delGoodsDTO"
            :toDoorForm="toDoorForm"
            :cangkuitem="cangkuitem"
            @changeTi="changeTi"
            @rowClick="getTimoney"
            ref="address"
          ></addressInfo>
        </div>
        <!-- 地址信息模块end -->
        <!-- 商品信息模块start -->
        <div class="Item_list">
          <goodsInfo
            :goodsInfoForm="goodsInfoForm"
            :goodsTypeOptions="goodsTypeOptions"
            @change="goodsInfoChange"
            @goodTypechange="goodTypechange"
            @del="delGoods"
            @edit="delGoods"
          ></goodsInfo>
        </div>
        <!-- 商品信息模块end -->
        <!-- 贸易信息模块start -->
        <div class="Item_list">
          <div class="weituo">
            <i class="el-icon-s-order" style="color: #63b947; font-size: 25px"></i>
            <p class="tittype">{{$t('i18n_trade_information')}}</p>
            <div class="addMore">
              <el-button icon="el-icon-upload" size="medium" type="text" @click="upload">{{$t('i18n_upload_clearance_documents')}}</el-button>
            </div>
          </div>
          <el-form size="small" label-position="right" label-width="106px" :model="tradeInfoForm" :rules="tradeInfoFormRules" ref="tradeForm">
            <el-form-item label-width="0">
              <el-checkbox-group v-model="declareType" @change="tradeInfoChange">
                <el-checkbox label="M" name="type" checked>{{$t('i18n_customs_declaration_with_Agent_license')}}</el-checkbox>
                <el-checkbox label="T" name="type">{{$t('i18n_customs_declaration_with_tax_refund')}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <!--
            <div v-if="tradeInfoForm.declareType[0] === 'T'">
              <el-row :gutter="5">
                <el-col :span="12">
                  <el-form-item label="退税联系电话" prop="declareTelephone">
                    <el-input v-model="tradeInfoForm.declareTelephone" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系人" prop="declareContacts">
                    <el-input v-model="tradeInfoForm.declareContacts" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="省市区" prop="TSAddres">
                    <el-cascader
                      style="width: 100%"
                      ref="refSsqname"
                      placeholder=""
                      :options="jackCitylist"
                      v-model="tradeInfoForm.TSAddres"
                      :props="defaultParams2"
                      @change="changeTSssq"
                    >
                    </el-cascader>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="详细地址" prop="declareAddress">
                    <el-input v-model="tradeInfoForm.declareAddress" style="width: 100%"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            -->
            <div class="Item_list" v-if="tradeInfoForm.declareType[0] === 'T'">
               <addressInfoDeclarer
                  :declarerDTO="declarerDTO">
                </addressInfoDeclarer>
            </div>
          </el-form>
          <el-upload
            class="upload-demo"
            ref="upload"
            :action="$store.baseUrl + '/busKY/uploadAirJobsBGInfo'"
            :headers="{
              token: Authorization.token
            }"
            :limit="1"
            :http-request="fileUpload"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-remove="handleRemove"
            :on-exceed="handleExceed"
          >
          </el-upload>
        </div>
        <!-- 贸易信息模块end -->
        <!-- 备注模块start -->
        <div class="Item_list">
          <div class="weituo">
            <i class="el-icon-paperclip" style="color: #63b947; font-size: 25px"></i>
            <p class="tittype">{{$t('i18n_remark')}}</p>
          </div>
          <el-form label-width="80px" size="small">
            <el-form-item :label="$t('i18n_delivery_remark')">
              <el-input v-model="delGoodsDTO.delGoodsRemarks"></el-input>
            </el-form-item>
            <el-form-item :label="$t('i18n_pickup_remark')">
              <el-input v-model="getGoodsDTO.getGoodsRemarks"></el-input>
            </el-form-item>
            <el-form-item :label="$t('i18n_Clients_tracking_number')">
              <el-input v-model="customerNo"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- 备注模块end -->
      </div>

      <feeDetail
        class="Item_list"
        :auto_fixed="auto_fixed"
        :allMoreFeeInfo="allMoreFeeInfo"
        :transportFeeForAir="transportFeeForAir"
        :pickFeeForAir="pickFeeForAir"
        :currencyCollection="currencyCollection"
        :calculatePrice="calculatePrice"
        :feeList="feeList"
        :pickFeeChecked="toDoorForm.isGetGoodsToDoor"
        :sendFeeChecked="toDoorForm.isSendGoodsToDoor"
        @submitOrder="entrust"
      ></feeDetail>

      <el-dialog
        :title="$t('i18n_Are_your_confirm_order')"
        center
        :visible.sync="dialogTableVisible"
        width="520px"
      >
        <div class="showDalog">
          <div class="header_text">
            <div class="count_center" style="margin-right: 50px">
              <span class="cangkutit" style="color: red">
                {{inWarehouseInfo.namec}}
              </span>
              <span class="ckttext" style="margin-top: 10px">{{$t('i18n_receving_warehosue')}}</span>
            </div>
            <div class="cangkutit" style="margin-right: 50px">
              <!-- <img src="../../assets/images/setIcon.png" alt=""> -->
              <img style="height:32px;" src="../../assets/airOrder.png" alt="" />
            </div>
            <div class="count_center">
              <span class="cangkutit" style="color: red">
                {{ toWarehouseInfo.namec }}
              </span>
              <span class="ckttext" style="margin-top: 10px">{{$t('i18n_destination_city')}}</span>
            </div>
          </div>
          <div
            class="goodlist"
            style="
              margin-top: 40px;
              width: 100%;
              float: left;
              padding: 0px 40px;
              box-sizing: border-box;
              margin-bottom: 30px;
            "
          >
            <p style="#999999">{{$t('i18n_estimated_cost')}}</p>
            <div style="padding: 5px">
              <p style="font-weight: bold; color: #333333">
                CNY {{ calculatePrice }}
              </p>
            </div>
          </div>
          <div class="Qdbtn LR_center" style="margin-top: 30px">
            <div
              @click="dialogTableVisible = false"
              class="btnstyle"
              style="
                height: 35px;
                background: #ffffff;
                border: 2px solid #dcdcdc;
                border-radius: 35px;
              "
            >
              {{$t('i18n_cancel')}}
            </div>
            <div
              @click="submitOrder"
              class="btnstyle"
              style="
                border: 1px solid #5ab53c;
                font-size: 30rpx;
                background: #ff3939;
                border-color: #ff3939;
                color: #ffffff;
              "
            >
              {{$t('i18n_confirm_order')}}
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 商品菜单 -->
      <el-dialog
        :visible.sync="successDialogVisi"
        width="650px"
        :modal="true"
        :close-on-click-modal="false"
      >
        <div class="count_center">
          <div class="centerCoutn">
            <div style="width: 100%; text-align: center;">
              <i
                style="font-size: 55px; color: #00c300"
                class="el-icon-success animate__animated animate__bounceInDown"
              ></i>
              <p
                style="
                  font-size: 20px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-top: 27px;
                "
              >
                {{$t('i18n_order_completed')}}
              </p>
              <p
                style="
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #999999;
                  margin-top: 8px;
                "
              >
                {{$t('i18n_waiting_shipment_to_warehoused')}}
              </p>
              <div class="countText">
                <p>{{$t('i18n_warehouse_number')}}：{{ orderInfo.innos ? orderInfo.innos : '' }}</p>
                <p>
                  {{$t('i18n_receiver')}}：<span>{{ sendFeeForAir.name }}</span>
                  <span style="margin-left: 10px">{{ sendFeeForAir.tel }}</span>
                </p>
                <p>
                  {{$t('i18n_consignee_address')}}：{{ sendFeeForAir.country }}{{ sendFeeForAir.city
                  }}{{ sendFeeForAir.address }}
                </p>
              </div>
            </div>
            <div class="btnWrap" style="width: 100%; margin-top: 44px">
              <div class="LR_center" style="width: 628px">
                <div class="btn1" @click="pathBilltab()">{{$t('i18n_track_order')}}</div>
                <div class="btn2" @click="nextSetbill()">{{$t('i18n_continue_to_order')}}</div>
                <div class="btn2" @click="labelDownload()">{{$t('i18n_download_labels')}}</div>
                <!-- <div class="btn2" @click="nextSetbill()">入仓单下单</div> -->
                <!-- <div class="btn2" @click="nextSetbill()">下载入仓单</div> -->
              </div>
              <!-- <el-button @click="downLoadBill()" style="margin-left:10px"
              type="success" size="mini">下载入仓单</el-button> -->
            </div>
          </div>
        </div>
      </el-dialog>
      <!-- 商品列表 -->
      <el-dialog title="商品列表" width="850px" :visible.sync="goodsTypeShow" :close-on-click-modal="false">
        <div class="typeHeader LR_center">
          <div>
            <el-input
              style="width: 314px"
              placeholder="请输入中文品名"
              v-model="page.name"
              class="input-with-select"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                type="primary"
                @click="GetgoodsType"
              >搜索</el-button>
            </el-input>
          </div>
          <div>
            <el-select
              clearable
              @change="GetgoodsType"
              v-model="page.goodstypeid"
              style="width: 100%"
              ref="changeFBAgoodtype"
              placeholder="请选择">
                <el-option v-for="res in goodstypelist" :key="res.id" :label="res.namec" :value="res.id"></el-option>
            </el-select>
          </div>
        </div>
        <div class="countTable" style="margin-top: 30px">
          <el-table
            ref="multipleTable"
            border
            :data="tabbar"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column label="中文名称" align="center" width="120">
              <template slot-scope="scope">{{ scope.row.namec }}</template>
            </el-table-column>
            <el-table-column
              prop="namee"
              label="英文品名"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column prop="materialc" align="center" label="中文材质">
            </el-table-column>
            <el-table-column prop="isHasBattery" align="center" label="是否带电">
              <template slot-scope="scope">{{scope.row.isHasBattery? '是' : '否'}}</template>
            </el-table-column>
            <el-table-column prop="isPowderLiquid" align="center" label="是否液体粉末">
              <template slot-scope="scope">{{scope.row.isPowderLiquid? '是' : '否'}}</template>
            </el-table-column>
            <el-table-column prop="goodstype" align="price" label="商品类型">
            </el-table-column>
          </el-table>
          <div style="width: 100%;
            margin-top:20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;"
          >
            <el-pagination background  @current-change="handleCurrentChange" layout="total,prev, pager, next" :page-size="20" :total="goodslisttotal"></el-pagination>
          </div>
        </div>
        <div slot="footer" style="width: 100%; margin-top:20px">
          <el-button type="primary" @click="changeGoodstype">确认选择</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import feeDetail from "./component/fee-detail.vue";
import goodsInfo from './component/goodsInfo.vue'
import addressInfo from './component/addressInfo.vue'
import addressInfoDeclarer from './component/addressInfoDeclarer.vue'
import { addPls } from '@/utils/placeholderI18n'
export default {
   components: {
    feeDetail,
    goodsInfo,
    addressInfo,
    addressInfoDeclarer
  },
  data() {
    return {
      Authorization: {
        ...JSON.parse(sessionStorage.getItem("Authorization"))
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      pickerSetTime: {
        disabledDate(time) {
          if (localStorage.getItem("todoorTime")) {
            return time.getTime() < Date.now();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      entrustInfo: { // 委托信息
        payType: '',
        inWarehouseId: '',
        inWarehouseTime: '',
        innos: '',
        toWarehouseId: '',
        orderType: 1,
        customsClearanceType: ''
      },
      entrustInfoRules: {
        payType: [{ required: true, message: this.addPls('i18n_pay_party', 'select'), trigger: 'change' }],
        inWarehouseTime: [{ required: true, message: this.addPls('i18n_warehouse_received_time', 'select'), trigger: 'change' }],
        customsClearanceType: [{ required: true, message: this.addPls('i18n_clearance_metods', 'select'), trigger: 'change' }]
      },
      inWarehouseInfo: {}, // 启运地仓库信息
      toWarehouseInfo: {}, // 目的城市信息
      cangkuLIst: [],
      toWarehouseList: [],
      auto_fixed: false,
      allMoreFeeInfo: {
        amount: 0,
        totalExpense: "0",
        feeItemDTOS: [],
      },
      transportFeeForAir: {
        checked: true,
        feeCode: "QBHYF",
        feeType: "Q",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "", //--单价
        cnyamount: "", //现有总价
        amount: "",
        piece: "1",
        price_unit: "",
        goodsTypeFeeDTOS: [],
      },
      sendFeeForAir: {
        checked: false,
        name: "",
        price: "", //--单价
        currency: "",
        cnycurrency: "", //现有币种
        cnyprice: "",
        cnyamount: "",
        amount: "",
        piece: "1",
      },
      pickFeeForAir: {
        //提货费
        checked: false,
        feeCode: "THF",
        price: "",
        currency: "",
        cnyprice: "",
        cnycurrency: "",
        cnyamount: "",
        amount: "",
        piece: 1,
        pickUpdate: "",
      },
      feeList:[],
      // 商品信息模块数据 start
      addGoodsForm: {
        GoodsList: [
          {
            goodsname: '',
            h: '',
            l: '',
            w: '',
            boxNum: '',
            weight: '',
            cbm: '',
            isBrand: false,
            isHasBattery: false,
            isPowderLiquid: false,
            goodstype: '',
            goodsTypeId: '',
            piece: ''
          }
        ]
      },
      goodsInfoForm: {
        GoodsList: []
      },
      goodsTypeShow: false,
      tabbar: [],
      goodsListIndex: 0,
      page: {
        pageNum: 1,
        pageSize: 10,
        goodstypeid: '',
        name: ''
      },
      goodslisttotal: 0,
      selectGoodslist: [],
      goodstypelist: [],
      goodsTypeOptions: [],
      // 商品信息模块数据 end
      defaultParams2: {
        value: "namec",
        label: "namec"
      },
      declareType: [],
      tradeInfoForm: {
        declareType: ['M'],
        declareTelephone: '',
        declareContacts: '',
        declareAddress: '',
        declareProvince: '',
        declareCity: '',
        declareArea: '',
        TSAddres: []
      },
      tradeInfoFormRules: {
        declareTelephone: [{ required: true, message: '退税联系电话不能为空', trigger: 'blur' }],
        declareContacts: [{ required: true, message: '退税联系人不能为空', trigger: 'blur' }],
        TSAddres: [{ required: true, message: '退税省市区不能为空', trigger: 'change' }],
        declareAddress: [{ required: true, message: '退税详细地址不能为空', trigger: 'blur' }]
      },
      dialogTableVisible: false,
      // 地址信息模块数据 start
      recGoodsDTO: { // 派送地址也就是收货信息
        recGoodsAddress: '',
        recGoodsArea: '',
        recGoodsCity: '',
        recGoodsCountry: '',
        recGoodsName: '',
        recGoodsTel: '',
        recGoodsRemarks: '',
        recGoodsId: ''
      },
      delGoodsDTO: { // 发货信息
        delGoodsId: '',
        delGoodsName: '',
        delGoodsRemarks: '',
        delGoodsTel: ''
      },
      declarerDTO: { // 退税报关
        declarerId: '',
        declarerName: '',
        declarerRemarks: '',
        declarerTel: ''
      },
      toDoorForm: {
        isGetGoodsToDoor: false,
        isSendGoodsToDoor: true,
        toDoorDate: ''
      },
      getGoodsDTO: { // 提货地址
        getGoodsAddress: '',
        getGoodsArea: '',
        getGoodsCity: '',
        getGoodsId: '',
        getGoodsName: '',
        getGoodsProvince: '',
        getGoodsTel: '',
        getGoodsRemarks: '',
        toDoorDate: ''
      },
      jackCitylist: [],
      // 地址信息模块数据 end
      // 运费
      finaArapAirBeforeAFFDTO: { // 空运费
        amount: 0,
        cnyamount: 0,
        currency: 0
      },
      finaArapAirBeforeTHFDTO: { // 提货费
        amount: 0,
        cnyamount: 0,
        currency: 0
      },
      uploadBgurl: [],
      cangkuitem: {}, // 入仓仓库信息
      PScangkuitem: {}, // 目的城市信息
      successDialogVisi: false,
      orderInfo: {}, // 订单提交成功后返回的信息
      customerId: '',
      id: '',
      productId: '',
      customerNo: ''
    }
  },
  computed: {
    currencyCollection() {},
    calculatePrice() { // 折合人民币
      let Totalmoney = 0; //总费用
      // let sendFeeForAir = 0; //配送费
      let transportFeeForAir = 0; //海运费
      let THFmoney = 0; //提货费
      transportFeeForAir = this.transportFeeForAir.cnyamount
        ? this.transportFeeForAir.cnyamount
        : 0;
      // if (this.sendFeeForAir.checked) {
      //   //如果有配送费
      //   sendFeeForAir = this.sendFeeForAir.cnyprice
      //     ? this.sendFeeForAir.cnyprice
      //     : 0;
      // }
      if (this.pickFeeForAir.checked) {
        //如果有提货费
        THFmoney = this.pickFeeForAir.cnyamount
          ? this.pickFeeForAir.cnyamount
          : 0;
      }

      if (transportFeeForAir) {
        Totalmoney += parseFloat(transportFeeForAir);
      }
      // if (sendFeeForAir) {
      //   Totalmoney += parseFloat(sendFeeForAir);
      // }
      if (THFmoney) {
        Totalmoney += parseFloat(THFmoney);
      }
      // 增值服务
      // if (this.allMoreFeeInfo.amount > 0) {
      //   Totalmoney += parseFloat(this.allMoreFeeInfo.amount);
      // }

      return Totalmoney.toFixed(2);
    },
    productName() {
      let productName = ''
      if (this.goodsTypeOptions.length) {
        productName = this.goodsTypeOptions[0].productName
      }
      return productName
    }
  },
  created() {
    // this.getOrderInfo()
  },
  mounted() {
    this.getOrderInfo()
    this.gettihuoLIst()
    // this.getGoodsTypeList()
    // this.getCangku()
    this.getWarehouse()
  },
  watch: {
    'formPop.ssqnames'(newValue) {
      this.ssqnames = newValue
    },
    goodsInfoForm: {
      deep: true,
      handler(val) {
        console.log(val)
        val.GoodsList.forEach((item, index) => {
          if (item.l&&item.h&&item.w) {
            item.cbm = parseFloat(item.l*item.h*item.w/1000000).toFixed(4)
            item.totalcbm = (item.cbm*item.boxNum).toFixed(4)
            item.totalweight = (item.weight*item.boxNum).toFixed(4)
          } else {
            item.cbm = 0
          }
        })
        // this.getHTFcount()
        // this.getTimoney()
      }
    }
  },
  methods: {
    getCangku() {
      //获取仓库
      this.axios
        .get("/warehouse/warehouseListAll")
        .then((res) => {
          this.cangkuLIst = res.data.datas
          this.cangkuLIst.forEach(item => {
            if (item.id === this.entrustInfo.inWarehouseId) {
              this.cangkuitem = item
            }
          })
      })
    },
    getWarehouse() { // 获取目的城市
      this.axios
        // .get("/warehouse/overseasWarehouseList")
        .get("/filedata/listPodCityByCounrtyId")
        .then((res) => {
          this.toWarehouseList = res.data.datas;
          // this.WarehouseList.forEach(item => {
          //   item.label = item.namec
          //   item.value = item.id
          // })
        })
        .catch((res) => {});
    },
    tradeInfoChange(val) {
      if(!val.length) {
        this.declareType = this.tradeInfoForm.declareType
        return
      }
      this.declareType = []
      this.declareType.push(val[1])
      this.tradeInfoForm.declareType = this.declareType
    },
    // 地址信息模块 start
    // 地址信息模块 end
    // 商品信息模块功能start
    addItem() {
      this.$refs.goodsForm.validate(valid => {
        if (valid) {
          const obj = JSON.parse(JSON.stringify(this.addGoodsForm.GoodsList[0]))
          this.goodsInfoForm.GoodsList.push(obj)
          const arr = ['isBrand', 'isHasBattery', 'isPowderLiquid']
          Object.keys(this.addGoodsForm.GoodsList[0]).forEach(key => {
            if (arr.indexOf(key) === -1) {
              this.addGoodsForm.GoodsList[0][key] = ''
            } else {
              this.addGoodsForm.GoodsList[0][key] = false
            }
          })
          this.$nextTick(() => {
            this.$refs.goodsForm.clearValidate()
          })
        }
      })
    },
    goodTypechange(id) {
      this.goodsTypeOptions.forEach(item => {
        if(item.id === id) {
          this.addGoodsForm.GoodsList[0].goodstype = item.cnName
        }
      })
      this.getHTFcount()
    },
    handleDelete(index) {
      this.goodsInfoForm.GoodsList.splice(index, 1)
    },
    GetgoodsType() {
      let that = this;
      this.axios.get(`/filedata/findKYItemCategoryList?name=${this.page.name}`).then((res) => {
        if (res.data.code == "200") {
          console.log(res.data.datas);
          that.tabbar = res.data.datas;
        } else {
        }
      })
      .catch((res) => {
        console.log(res);
      });
    },
    showgoodsType(index) {
      this.GetgoodsType()
      this.goodsTypeShow = true
      this.goodsListIndex = index
    },
    changeGoodstype() {
      const item = this.selectGoodslist[0]
      this.goodsTypeShow = false
      this.goodsInfoForm.GoodsList[this.goodsListIndex].goodsname = item.namec
      this.goodsInfoForm.GoodsList[this.goodsListIndex].isBrand = item.hasBrand
      this.goodsInfoForm.GoodsList[this.goodsListIndex].isHasBattery = item.hasBattery
      this.goodsInfoForm.GoodsList[this.goodsListIndex].isPowderLiquid = item.hasLiquidPowder
      this.goodsInfoForm.GoodsList[this.goodsListIndex].goodsItemId = item.id
      this.goodsInfoForm.GoodsList[this.goodsListIndex].goodstype = item.goodstype
      this.goodsInfoForm.GoodsList[this.goodsListIndex].goodstypeid = item.goodstypeid
      this.page.name = ''
      this.getHTFcount()
    },
    handleSelectionChange(val) {
      this.selectGoodslist = val;
    },
    handleCurrentChange(val) {
      this.page.pageNum = val
      this.getGoodsData()
    },
    getGoodsTypeList() {
      this.axios.get(`/filedata/findKYDatGoodsSetInfoDTOList?id=${this.productId}`).then(res => {
        this.goodsTypeOptions = res.data.datas
      })
    },
    goodsInfoChange() {
      setTimeout(() => {
        this.getTimoney()
        this.getHTFcount()
      }, 0)
    },
    delGoods(index) {
      this.goodsInfoForm.GoodsList.splice(index, 1)
    },
    // 商品信息模块功能end
    gettihuoLIst() { //省市区列表
      let user = sessionStorage.getItem("Authorization");
      user = JSON.parse(user);
      this.axios
        .post(`filedata/filedataProvinces`, {}, {})
        .then((res) => {
          if (res.data.code == 200) {
            this.jackCitylist = res.data.datas;
          } else {
            this.$message.info("服务器繁忙");
          }
        })
        .catch((res) => {
          this.$message.info("服务器繁忙");
        })
    },
    changeTSssq(val) {
      this.tradeInfoForm.declareProvince = val[0]
      this.tradeInfoForm.declareCity = val[1]
      this.tradeInfoForm.declareArea = val[2]
    },
    // 运费计算
    getHTFcount() { // 获取运费
      let that = this;
      let itemDTOS = [];
      this.goodsInfoForm.GoodsList.forEach((item, index) => {
        let goodItem = {
          cbm: 0,
          weight: 0,
          goodsTypeId: "",
        };
        goodItem.cbm = item.totalcbm;
        goodItem.goodsTypeId = item.goodsTypeId;
        goodItem.weight = item.totalweight;
        itemDTOS.push(goodItem);
      });

      let params = {
        // feeCode: "QBHYF",
        pollandId: this.entrustInfo.inWarehouseId, //起运地id,
        podlandId: this.entrustInfo.toWarehouseId, //目的地仓库
        customerId: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id
        itemDTOS: itemDTOS,
      };
      this.axios.post(`/KYFee/calAirFeeQuoteInfo`, params).then((res) => {
        console.log(res.data.data);
        if (res.data.code == "200") {
          that.transportFeeForAir.price = res.data.data.price;
          that.transportFeeForAir.currency = res.data.data.currency;
          that.transportFeeForAir.cnyprice = res.data.data.price;

          that.transportFeeForAir.amount = res.data.data.amount;
          that.transportFeeForAir.cnyamount = res.data.data.cnyamount;
          that.transportFeeForAir.goodsTypeFeeDTOS =
            res.data.data.goodsTypeFeeDTOS;
          that.goodsInfoForm.GoodsList.forEach((item, index) => {
            item.goodstype = res.data.data.itemDTOS[index].goodsTypeName;
            item.heavyUnitPrice =
              res.data.data.itemDTOS[index].heavyUnitPrice;
          });
          this.finaArapAirBeforeAFFDTO.amount = res.data.data.amount
          this.finaArapAirBeforeAFFDTO.cnyamount = res.data.data.cnyamount
          this.finaArapAirBeforeAFFDTO.currency = res.data.data.currency
          localStorage.setItem(
            "transportFeeForAir",
            JSON.stringify(that.transportFeeForAir)
          ); //海运费
        } else {
          that.transportFeeForAir.cnyamount = 0;
          that.transportFeeForAir.amount = 0;
          that.transportFeeForAir.price = "";
          that.transportFeeForAir.currency = "";
          that.transportFeeForAir.cnyprice = "";
          that.transportFeeForAir.goodsTypeFeeDTOS = [];
          this.finaArapAirBeforeAFFDTO.amount = 0
          this.finaArapAirBeforeAFFDTO.cnyamount = 0
          this.finaArapAirBeforeAFFDTO.currency = ''
        }
      })
      .catch((res) => {
        console.log(res);
      });
    },
    changeTi(val) {
      console.log(val);
      this.pickFeeForAir.checked = val
      // debugger
      if (val) {
        this.getTimoney();
      }
      // localStorage.setItem("pickFeeForAir", JSON.stringify(this.pickFeeForAir));
    },
    getTimoney() { // 获取提货费
      if (!this.toDoorForm.isGetGoodsToDoor) {
        return;
      }
      let weight = 0,
        cbm = 0;
      this.goodsInfoForm.GoodsList.forEach((item, index) => {
        weight += parseFloat(+item.totalweight);
        cbm += parseFloat(+item.totalcbm);
      });
      if (!(this.getGoodsDTO.getGoodsProvince&&this.getGoodsDTO.getGoodsCity)) {
        return
      }
      let params = {};
      params = {
        province: this.getGoodsDTO.getGoodsProvince, //省 name
        city: this.getGoodsDTO.getGoodsCity, //市 name
        area: this.getGoodsDTO.getGoodsArea, //区 name
        customerId: JSON.parse(sessionStorage.getItem("Authorization"))
          .customerid, //客户id
        feeCode: "THF",
        inWarehouseId: JSON.parse(localStorage.getItem("cangkuitem")).id,
        weight: weight,
        cbm: cbm,
      };
      this.axios.post(`/KYFee/getKYPickUpFee`, params).then((res) => {
        if (res.data.code == "200") {
          console.log(this.pickFeeForAir);

          this.pickFeeForAir.price = res.data.data.price; //价格
          this.pickFeeForAir.currency = res.data.data.currency; //币种
          this.pickFeeForAir.cnyprice = res.data.data.cnyprice; //--隐藏单价
          this.pickFeeForAir.cnycurrency = res.data.data.cnycurrency; //”CNY”--换算币种
          this.pickFeeForAir.cnyamount = res.data.data.cnyprice; //”CNY”--换算币种
          this.pickFeeForAir.amount = res.data.data.price;
          this.pickFeeForAir.minKilometer = res.data.data.minKilometer;
          this.pickFeeForAir.maxKilometer = res.data.data.maxKilometer;
          this.pickFeeForAir.checked = true
          // localStorage.setItem(
          //   "pickFeeForAir",
          //   JSON.stringify(this.pickFeeForAir)
          // );
        } else {
          // this.$message.error(res.data.message)
          this.pickFeeForAir.price = 0
          this.pickFeeForAir.currency = ''
          this.pickFeeForAir.cnyprice = 0
          this.pickFeeForAir.cnycurrency = ''
          this.pickFeeForAir.cnyamount = 0
          this.pickFeeForAir.amount = 0
          this.pickFeeForAir.minKilometer = 0
          this.pickFeeForAir.maxKilometer = 0
        }
      })
      .catch((res) => {
        console.log(res);
      });
    },
    changeSh(value) {
      this.sendFeeForAir.checked = value
      // this.sendFeeForAir.checked = !this.sendFeeForAir.checked;
      if (value) {
        this.getPSFcount();
      }
      localStorage.setItem("sendFeeForAir", JSON.stringify(this.sendFeeForAir));
    },
    getPSFcount() {
      // if (!this.sendFeeForAir.tel) {
      //   return;
      // }
      let weight = 0,
        cbm = 0;
      this.goodsInfoForm.GoodsList.forEach((item, index) => {
        weight += parseFloat(+item.weight);
        cbm += parseFloat(+item.cbm);
      });
      if (!(cbm > 0) || !this.goodsInfoForm.GoodsList[0].goodsname) {
        // this.$message.info('送货:请先添加商品')
        return;
      }
      // this.loadin = true;
      let params = {
        cbm: cbm,
        podlandId: this.sendFeeForAir.countryId, //目的国id
        podlandCityId: this.sendFeeForAir.cityId, //目的城市id
        podlandAreaId: this.sendFeeForAir.areaId, //目的仓库id
        toWarehouseId: JSON.parse(localStorage.getItem("PScangkuitem")).id,
      };
      this.axios.post(`/KYFee/getKYDeliveryFee`, params).then((res) => {
        // console.log(res);
        this.sendFeeForAir.price = res.data.data.price;
        this.sendFeeForAir.currency = res.data.data.currency; //币种
        this.sendFeeForAir.cnyprice = res.data.data.cnyprice; //单价
        this.sendFeeForAir.amount = res.data.data.price;
        this.sendFeeForAir.cnyamount = res.data.data.price;
        localStorage.setItem(
          "sendFeeForAir",
          JSON.stringify(this.sendFeeForAir)
        );
        // this.sendFeeForAir = JSON.parse(JSON.stringify(this.sendFeeForAir));
      })
      .catch((res) => {
        console.log(res);
      });
    },
    // 运费计算
    upload() {
      this.$refs.upload.$refs['upload-inner'].handleClick()
    },
    handleSuccess(res) {
      console.log(res);
      this.uploadBgurl.push(res.message)
    },
    handleError(err) {
      this.$message.error(this.$t('i18n_File_upload_failed'))
    },
    handleRemove(file) {
      this.uploadBgurl.forEach((item, index) => {
        if (item.indexOf(file.name) !== -1) {
          this.uploadBgurl.splice(index, 1)
        }
      })
    },
    handleExceed() {
      this.$message.warning(this.$t('i18n_Upload_up_to_one_file'))
    },
    fileUpload(fileObj) {
      let fd = new FormData()
      fd.append('file', fileObj.file)
      this.axios.post('/busKY/uploadAirJobsBGInfo', fd).then(res => {
        console.log(res.data)
        this.uploadBgurl.push(res.data.message)
        this.$message.success(this.$t('i18n_File_uploaded_successfully'))
      })
    },
    entrust() {
      let validArr = []
      this.$refs.entrustForm.validate((valid) => {
        validArr.push(valid)
      })
      //if (this.toDoorForm.isGetGoodsToDoor) { // 上门取件才校验
      //  this.$refs.getGoodsInfo.validate((valid) => {
      //     validArr.push(valid)
      //  })
      // }
      // this.$refs.goodsForm.validate((valid) => {
      //   validArr.push(valid)
      // })
      if (!this.goodsInfoForm.GoodsList.length) {
        const value = this.$refs.address.submit()
        validArr.push(value)
      }
      if (this.tradeInfoForm.declareType[0] === 'T') {
        this.$refs.tradeForm.validate(valid => {
          validArr.push(valid)
        })
      }
      const flag = validArr.every(valid => valid)
      if (flag) {
        this.cangkuLIst.forEach(item => {
          if(item.id === this.entrustInfo.inWarehouseId) {
            this.inWarehouseInfo = item
          }
        })
        this.toWarehouseList.forEach(item => {
          if (item.id === this.entrustInfo.toWarehouseId) {
            this.toWarehouseInfo = item
          }
        })
        this.dialogTableVisible = true
      } else {
        this.scrollToFalse()
      }
    },
    scrollToFalse() {
      this.$nextTick(() => {
        let isError = document.getElementsByClassName("is-error")
        isError[0].scrollIntoView({
          block: "center",
          behavior: "smooth",
        })
      })
    },
    submitOrder() { // 提交订单
      let params = {
        busAirjobsBeforeGoodsDTOList: this.goodsInfoForm.GoodsList,
        ...this.tradeInfoForm,
        delGoodsDTO: this.delGoodsDTO,
        getGoodsDTO: this.getGoodsDTO,
        ...this.toDoorForm,
        recGoodsDTO: this.recGoodsDTO,
        ...this.entrustInfo,
        customerId: this.Authorization.customerid,
        source: 'I',
        finaArapAirBeforeAFFDTO: {
          amount: this.transportFeeForAir.amount,
          cnyamount: this.transportFeeForAir.cnyamount,
          currency: this.transportFeeForAir.currency
        },
        finaArapAirBeforeTHFDTO: {
          amount: this.pickFeeForAir.amount,
          cnyamount: this.pickFeeForAir.cnyamount,
          currency: this.pickFeeForAir.currency
        },
        uploadBgurl: this.uploadBgurl.join(),
        id: this.id,
        innos: this.$route.query.innos,
        productId: this.goodsTypeOptions[0].id,
        declareContacts: this.declarerDTO.declarerName,
        declareTelephone: this.declarerDTO.declarerTel,
        customerNo: this.customerNo
      }
      params.declareType = params.declareType[0]
      this.axios.post('/busKY/updateAirjobsBefore', params).then(res => {
        if (res.data.code === 200) {
          this.orderInfo = res.data.data
          this.successDialogVisi = true
        } else {
          this.$message.error(res.data.message)
        }
      })
      this.dialogTableVisible = false
    },
    pathBilltab() { // 查看订单详情
      this.$router.push({
        name: "AirOrderDetail",
        query: {
          nos: this.orderInfo.innos,
          state: '1'
        }
      })
    },
    nextSetbill() { // 继续下单
      this.successDialogVisi = false
      this.$router.push('/index/placeOrder/placeIndex')
    },
    labelDownload () {
      this.axios.get(`/busKY/downKYOrderLabel/${this.orderInfo.innos}`).then(res => {
        window.open(res.data.data)
      })
    },
    async getOrderInfo() {
      await this.axios.get(`/busKY/findAirjobsBefore/${this.$route.query.innos}`).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data
          this.entrustInfo.customsClearanceType = data.customsClearanceType
          this.entrustInfo.inWarehouseTime = data.inWarehouseTime
          this.entrustInfo.innos = data.innos
          this.entrustInfo.orderType = data.orderType
          this.entrustInfo.payType = data.payType
          this.entrustInfo.inWarehouseId = data.inWarehouseId
          this.entrustInfo.toWarehouseId = data.toWarehouseId
          this.tradeInfoForm.declareAddress = data.declareAddress
          this.tradeInfoForm.declareArea = data.declareArea
          this.tradeInfoForm.declareCity = data.declareCity
          this.tradeInfoForm.declareContacts = data.declareContacts
          this.tradeInfoForm.declareProvince = data.declareProvince
          this.tradeInfoForm.declareTelephone = data.declareTelephone
          this.tradeInfoForm.declareType.push(data.declareType)
          this.productId = data.productId
          Object.keys(this.delGoodsDTO).forEach(key => { // 发货人
            this.delGoodsDTO[key] = data.delGoodsDTO?data.delGoodsDTO[key]:''
          })
          Object.keys(this.getGoodsDTO).forEach(key => { // 提货联系人
            this.getGoodsDTO[key] = data.getGoodsDTO?data.getGoodsDTO[key]:''
          })
          Object.keys(this.recGoodsDTO).forEach(key => { // 收货人
            this.recGoodsDTO[key] = data.recGoodsDTO?data.recGoodsDTO[key]:''
          })
          this.toDoorForm.isGetGoodsToDoor = data.isGetGoodsToDoor // 上门取件
          this.toDoorForm.isSendGoodsToDoor = data.isSendGoodsToDoor // 送货上门
          this.toDoorForm.toDoorDate = data.toDoorDate
          this.cangkuitem.id = data.inWarehouseId
          this.PScangkuitem.id = data.toWarehouseId
          this.customerId = data.customerId,
          this.id = data.id
          this.getGoodsTypeList()
          this.getCangku()
        }
      })
    },
    addPls,
  }
}
</script>
<style lang="scss" scoped>
@import './component/style.scss';

.center_wrap {
  display: flex;
  display: -webkit-flex;
  width: 1388px;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/airOrder/editAirOrder.vue